import { SITE_URL } from '../../constants'
import { buildCaseStudySchema } from '../../builders/caseStudy'
import { PageMeta } from '../../types'

const description = "金融マーケット関係者に、世界の情報を素早くご提供するアプリを開発いたしました。このアプリは、金融関係のお客様に要求されるクラウド上での高いセキュリティレベルの実現と、Xamarinを利用した1ソースでマルチデバイス対応をしています。弊社はこのアプリ開発を実施しました。"

const primaryImage = "https://www.i3design.jp/ogp_logo.png"

export const quickPageMeta: PageMeta = {
  title: "QUICK Global Alert | 事例 | i3DESIGN アイスリーデザイン",
  description,
  keyword: "UIUX モバイルアプリ システム化 DX推進 フロントエンド開発",
  image: primaryImage,
  url: `${SITE_URL}/cases/quick/`,
}

export const quickSchema = buildCaseStudySchema({
  slug: "quick",
  pageTitle: quickPageMeta.title,
  description: quickPageMeta.description,
  headline: "QUICK Global Alert",
  alternativeHeadline: "株式会社QUICK",
  primaryImage,
  images: ["https://www.i3design.jp/ogp_logo.png","https://www.i3design.jp/images/img/cases/caseStudyTop/quick.webp"],
  clientName: "株式会社QUICK",
  breadcrumbLabel: "QUICK Global Alert",
})
